var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRiskWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 69,
    height: 92,
    viewBox: "0 0 69 92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "prefix__a",
    d: "M40.25 24.438V0H4.312C1.922 0 0 1.923 0 4.313v83.374C0 90.078 1.923 92 4.313 92h60.374C67.078 92 69 90.077 69 87.687V28.75H44.562c-2.371 0-4.312-1.94-4.312-4.313zM34.516 73C37.148 73 39 74.871 39 77.516 39 80.13 37.148 82 34.516 82 31.884 82 30 80.129 30 77.516 30 74.871 31.884 73 34.516 73zM38 36l-.595 32h-5.81L31 36h7zm9.096-36c1.15 0 2.246.45 3.055 1.258l17.591 17.61c.809.808 1.258 1.904 1.258 3.036V23H46V0h1.096z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#B3C5C5",
    fillRule: "nonzero",
    xlinkHref: "#prefix__a"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiskWarning);
export default __webpack_public_path__ + "static/media/risk-warning.751f635b.svg";
export { ForwardRef as ReactComponent };